<template>
  <div class="column explanation-card-container">
    <div class="icon-container">
      <div class="icon-box">
        <img :src="iconPath" :alt="iconUrl" />
      </div>
    </div>

    <div>
      <h3 class="card-title">{{ index + 1 }}. {{ $t(titles[index]) }}</h3>
      <p>
        {{ $t(texts[index]) }}
      </p>
    </div>

    <div v-if="hasButton" class="mt-auto">
      <a target="_blank" href="https://memodioh44-1dd46.kxcdn.com/website/diagnosesicherung-memodio_20.06.2023.pdf">
        <button class="card-button">{{ $t("aokPlus.downloadLetter") }}</button>
      </a>
    </div>
  </div>
</template>

<script>
import HealthInsurances from "~/models/healthInsurances.js"

export default {
  name: "HealthInsuranceExplanationCard",
  props: {
    healthInsurance: {
      type: String,
      default: HealthInsurances.aokPlus,
    },
    iconUrl: {
      type: String,
      required: true,
    },
    hasButton: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  computed: {
    titles() {
      if (this.healthInsurance === HealthInsurances.mobil) {
        return ["mobil.firstCardTitle", "mobil.secondCardTitle", "mobil.thirdCardTitle"]
      }
      if (this.healthInsurance === HealthInsurances.aokRps) {
        return ["aokRps.firstCardTitle", "aokRps.secondCardTitle", "aokRps.thirdCardTitle", "aokRps.fourthCardTitle"]
      }
      return ["aokPlus.firstCardTitle", "aokPlus.secondCardTitle", "aokPlus.thirdCardTitle"]
    },
    iconPath() {
      return `/images/health_insurances/${this.iconUrl}`
    },
    texts() {
      if (this.healthInsurance === HealthInsurances.mobil) {
        return ["mobil.firstCardText", "mobil.secondCardText", "mobil.thirdCardText"]
      }
      if (this.healthInsurance === HealthInsurances.aokRps) {
        return ["aokPlus.firstCardText", "aokPlus.secondCardText", "aokRps.thirdCardText", "aokRps.fourthCardText"]
      }
      return ["aokPlus.firstCardText", "aokPlus.secondCardText", "aokPlus.thirdCardText", "aokPlus.fourthCardText"]
    },
  },
}
</script>

<style scoped lang="scss">
.explanation-card-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f9fafb;
  padding: 1.5rem !important;
  min-height: 450px;
  border-radius: 20px;

  @media (max-width: $mobile) {
    min-height: auto;
  }
}

.card-title {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1rem;
}

.icon-container {
  display: flex;
  width: 100%;
  justify-content: flex-start;
  margin-bottom: 2rem;

  .icon-box {
    width: 3rem;
    height: 3rem;
    background-color: $brandpurple;
    display: grid;
    align-items: center;
    justify-items: center;
    border-radius: 0.6rem;

    @media (max-width: $tablet) {
      width: 2rem;
      height: 2rem;
    }
  }

  @media (max-width: $tablet) {
    margin-bottom: 0.5rem;
  }
}
.card-button {
  background-color: $brandpurple;
  color: white;
  padding: 0.625rem 1.125rem;
  border-radius: 0.5rem;
  border: none;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  margin-top: 1rem;

  &:hover {
    background-color: darken($brandpurple, 10%);
  }
  text-decoration: underline;
}
</style>
